import { Crown } from "lucide-react";
import { useProState } from "../lib/pro";

export default function UpgradeButton({ variant = "primary", label = "Upgrade to Pro — $9/month", className = "", testid = "upgrade-btn" }) {
  const { openUpgrade } = useProState();
  const base = "inline-flex items-center justify-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium transition-all active:scale-[0.97]";
  const styles = {
    primary: "bg-brand-gold text-brand-ink hover:brightness-95 shadow-sm",
    ghost: "bg-brand-gold/10 text-brand-gold hover:bg-brand-gold/20",
    outline: "border border-brand-gold/40 text-brand-gold hover:bg-brand-gold/10",
  };
  return (
    <button
      onClick={openUpgrade}
      className={`${base} ${styles[variant] || styles.primary} ${className}`}
      data-testid={testid}
    >
      <Crown className="w-3.5 h-3.5" strokeWidth={2.5} />
      {label}
    </button>
  );
}
